export default __webpack_public_path__ + "cd24e9adb841ccb0ad49f32296cac2ca.png";